import { LocationSelect } from 'search'
import { languageSelector } from 'i18n/selectors'
import { useMediaQuery } from 'react-responsive'
import { GRID_BREAKPOINT_SM } from 'shared/breakpoints'

function NavSearch() {
    const [isFocused, setIsFocused] = React.useState(false)
    const isDesktop = useMediaQuery({ minWidth: GRID_BREAKPOINT_SM })
    const icon = isDesktop && 'search'

    return (
        <div
            className={`indigo-nav-search ${isFocused ? 'is-focused' : ''}`}
            tabIndex="0"
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}>
            <LocationSelect size="small" icon={icon} isClearable={true} />
        </div>
    )
}

const navSearchConfigurationSelector = createStructuredSelector({
    language: languageSelector,
})

export default connect(navSearchConfigurationSelector)(NavSearch)
